export default __webpack_public_path__ + "static/media/VerificationName.b927e32a.svg";